import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faCog,
    faUser,
    faCloudUploadAlt,
    faCheckCircle as faCheckCircleRegular,
    faSpinner,
    faTimesCircle,
    faDatabase,
    faEyeSlash,
} from '@fortawesome/pro-regular-svg-icons'

import {
    faTimes,
    faHome,
    faFile,
    faFileAlt,
    faBriefcase,
    faTasks,
    faUsers,
    faArrowLeft as falArrowLeft,
    faArrowRight as falArrowRight,
} from '@fortawesome/pro-light-svg-icons'

import {
    faCheckCircle,
    faArrowCircleUp,
    faArrowAltLeft,
    faChevronDown,
    faDownload,
    faArrowDown,
    faHeadset,
} from '@fortawesome/pro-solid-svg-icons'

library.add(
    faHome,
    faCog,
    faUser,
    faCloudUploadAlt,
    faFile,
    faFileAlt,
    faTimes,
    faCheckCircle,
    faCheckCircleRegular,
    faArrowAltLeft,
    faBriefcase,
    faTasks,
    faUsers,
    faArrowCircleUp,
    faChevronDown,
    faSpinner,
    faTimesCircle,
    faDownload,
    faArrowDown,
    faDatabase,
    faHeadset,
    faEyeSlash,
    falArrowLeft,
    falArrowRight,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
